export const FILE_SIZE_LIMIT = 1024 * 1024; // 1MB
